/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type TradePromo_displayInfo$ref = any;
export type PdpSharedPromoCode_displayInfo$ref = any;
export type PdpSharedPromoCode_displayInfo = {
    readonly pricing: {
        readonly showSale: boolean | null;
        readonly showNet: boolean | null;
    } | null;
    readonly " $fragmentRefs": TradePromo_displayInfo$ref;
    readonly " $refType": PdpSharedPromoCode_displayInfo$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpSharedPromoCode_displayInfo",
    "type": "ItemDisplayInfo",
    "metadata": null,
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "isTrade",
            "type": "Boolean"
        }
    ],
    "selections": [
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "pricing",
            "storageKey": null,
            "args": null,
            "concreteType": "PriceInfoDisplay",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "showSale",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "showNet",
                    "args": null,
                    "storageKey": null
                }
            ]
        },
        {
            "kind": "Condition",
            "passingValue": true,
            "condition": "isTrade",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "TradePromo_displayInfo",
                    "args": null
                }
            ]
        }
    ]
} as any);
(node as any).hash = '1fc1abb9ac00c3c0a772e5327e45d8d6';
export default node;
